import * as Types from '../../graphql-types';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IGQLCloneCourseMutationVariables = Types.Exact<{
  input: Types.IGQLJrnyCloneCourseInput;
}>;


export type IGQLCloneCourseMutation = { __typename: 'Mutation', jrnyCloneCourse: { __typename: 'JrnyCourse', id: string, name: string, organizationId: string } };

export type IGQLCloneCourseToOrganizationMutationVariables = Types.Exact<{
  input: Types.IGQLJrnyCloneCourseToOrganizationInput;
}>;


export type IGQLCloneCourseToOrganizationMutation = { __typename: 'Mutation', jrnyCloneCourseToOrganization: { __typename: 'JrnyCourse', id: string, name: string, organizationId: string } };

export type IGQLCourseTargetOrganizationsQueryVariables = Types.Exact<{
  courseId: Types.Scalars['ID']['input'];
}>;


export type IGQLCourseTargetOrganizationsQuery = { __typename: 'Query', jrnyCourseTargetOrganizations: Array<{ __typename: 'JrnyOrganization', id: string, name: string, logo?: { __typename: 'FileObject', id: string, url: string } | null }> };


export const CloneCourseDocument = gql`
    mutation cloneCourse($input: JrnyCloneCourseInput!) {
  jrnyCloneCourse(input: $input) {
    id
    name
    organizationId
  }
}
    `;

export function useCloneCourseMutation() {
  return Urql.useMutation<IGQLCloneCourseMutation, IGQLCloneCourseMutationVariables>(CloneCourseDocument);
};
export const CloneCourseToOrganizationDocument = gql`
    mutation cloneCourseToOrganization($input: JrnyCloneCourseToOrganizationInput!) {
  jrnyCloneCourseToOrganization(input: $input) {
    id
    name
    organizationId
  }
}
    `;

export function useCloneCourseToOrganizationMutation() {
  return Urql.useMutation<IGQLCloneCourseToOrganizationMutation, IGQLCloneCourseToOrganizationMutationVariables>(CloneCourseToOrganizationDocument);
};
export const CourseTargetOrganizationsDocument = gql`
    query courseTargetOrganizations($courseId: ID!) {
  jrnyCourseTargetOrganizations(courseId: $courseId) {
    id
    name
    logo {
      id
      url
    }
  }
}
    `;

export function useCourseTargetOrganizationsQuery(options: Omit<Urql.UseQueryArgs<IGQLCourseTargetOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<IGQLCourseTargetOrganizationsQuery, IGQLCourseTargetOrganizationsQueryVariables>({ query: CourseTargetOrganizationsDocument, ...options });
};